import { Link } from "react-router-dom";
import { Mic, Play } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import episodes from "@/content/podcasty.json";

// Vždy nejnovější PUBLIKOVANÁ epizoda (má audioUrl). Nová epizoda v podcasty.json
// se na kartě projeví automaticky, bez zásahu do úvodní stránky.
const latest = [...episodes]
  .filter((e) => e.audioUrl)
  .sort((a, b) => new Date(b.date) - new Date(a.date))[0];

export const PodcastPromo = () => {
  const reduce = useReducedMotion();
  if (!latest) return null;

  const card = (
    <Link
      to={`/podcasty/${latest.slug}`}
      data-testid="podcast-promo"
      className="group relative z-10 mt-6 w-full max-w-xs mx-auto lg:mx-0 lg:mt-0 lg:absolute lg:bottom-0 lg:left-0 lg:translate-y-2/3 lg:-translate-x-6 lg:w-72 block bg-white border border-[#EFE7D6] rounded-2xl shadow-[0_14px_40px_rgba(37,37,37,0.10)] hover:shadow-[0_18px_50px_rgba(182,154,88,0.22)] hover:border-[#B69A58] transition-[box-shadow,border-color] duration-300 p-4 lg:p-5 text-left"
    >
      <div className="flex items-center gap-3 lg:gap-4">
        <span
          className="flex items-center justify-center w-11 h-11 lg:w-12 lg:h-12 rounded-full border border-[#B69A58]/50 bg-[#B69A58]/10 text-[#B69A58] shrink-0"
          aria-hidden="true"
        >
          <Mic className="h-5 w-5 lg:h-6 lg:w-6" strokeWidth={1.5} />
        </span>
        <span className="min-w-0">
          <span className="block text-[10px] uppercase tracking-[0.2em] text-[#B69A58] font-semibold">
            Nový díl podcastu
          </span>
          <span className="block font-display text-base lg:text-lg text-[#252525] leading-snug mt-1.5">
            {latest.title}
          </span>
          <span className="mt-2.5 inline-flex items-center gap-2 whitespace-nowrap text-[11px] uppercase tracking-widest font-semibold text-[#252525] group-hover:text-[#B69A58] transition-colors duration-300">
            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#B69A58] text-white" aria-hidden="true">
              <Play className="h-2.5 w-2.5 ml-px" fill="currentColor" />
            </span>
            Poslechnout epizodu
          </span>
        </span>
      </div>
    </Link>
  );

  if (reduce) return card;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      {card}
    </motion.div>
  );
};
